
(function () {
  function finalBlackLogoAndPriceRightFix() {
    var header = document.getElementById("goldenHomeFileHero");

    if (header) {
      var isHome = header.classList.contains("ghHomeHeroMode");
      var logo = header.querySelector(".ghFileLogo img");

      if (logo) {
        var desired = isHome ? window.GH_WHITE_LOGO_URL : window.GH_BLACK_LOGO_URL;

        if (!isHome && desired) {
          logo.setAttribute("src", desired);
        }

        logo.style.display = "block";
        logo.style.visibility = "visible";
        logo.style.opacity = "1";
        logo.style.width = "auto";
        logo.style.height = window.innerWidth <= 749 ? "49px" : "64px";
        logo.style.maxWidth = window.innerWidth <= 749 ? "86px" : "145px";
        logo.style.filter = "none";
      }

      header.querySelectorAll(".ghFileLogo img").forEach(function (img, index) {
        if (index > 0) {
          img.style.display = "none";
          img.style.visibility = "hidden";
          img.style.opacity = "0";
          img.style.width = "0";
          img.style.height = "0";
        }
      });
    }

    var root = document.getElementById("goldenHomeTrendingTabs");
    if (root) {
      root.querySelectorAll("*").forEach(function (el) {
        var text = (el.textContent || "").trim().toUpperCase();
        if ((text === "TRENDING" || text === "NEW ARRIVAL") && !el.querySelector("img") && el.children.length <= 1) {
          el.style.display = "none";
          el.style.visibility = "hidden";
          el.style.height = "0";
          el.style.minHeight = "0";
          el.style.maxHeight = "0";
          el.style.margin = "0";
          el.style.padding = "0";
          el.style.overflow = "hidden";
        }
      });

      root.querySelectorAll(".ghProductPrice").forEach(function (box) {
        var main = box.querySelector(".ghMainPrice");
        var currency = box.querySelector(".ghMainPrice .ghPriceCurrency");
        var sale = box.querySelector(".ghMainPrice .ghPriceAmount");
        var compare = box.querySelector(".ghComparePrice");

        box.style.display = "grid";
        box.style.gridTemplateColumns = "auto minmax(0, 1fr)";
        box.style.gridTemplateRows = "auto auto";
        box.style.gridTemplateAreas = '"pkr sale" "pkr compare"';
        box.style.background = "transparent";
        box.style.border = "0";
        box.style.borderRadius = "0";
        box.style.boxShadow = "none";
        box.style.padding = "0";
        box.style.overflow = "visible";

        if (main) {
          main.style.display = "contents";
          main.style.background = "transparent";
          main.style.border = "0";
          main.style.padding = "0";
        }

        if (currency) {
          currency.style.gridArea = "pkr";
          currency.style.justifySelf = "start";
          currency.style.alignSelf = "center";
          currency.style.background = "#000000";
          currency.style.color = "#ffffff";
        }

        if (sale) {
          sale.style.gridArea = "sale";
          sale.style.justifySelf = "end";
          sale.style.textAlign = "right";
          sale.style.color = "#d60000";
          sale.style.background = "transparent";
          sale.style.textDecoration = "none";
        }

        if (compare && !compare.classList.contains("isEmpty")) {
          compare.style.gridArea = "compare";
          compare.style.justifySelf = "end";
          compare.style.justifyContent = "flex-end";
          compare.style.textAlign = "right";
          compare.style.background = "transparent";
          compare.style.border = "0";
          compare.querySelectorAll(".ghPriceCurrency, .ghPriceAmount").forEach(function (item) {
            item.style.color = "#6b6b6b";
            item.style.textDecoration = "line-through";
            item.style.textAlign = "right";
          });
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", finalBlackLogoAndPriceRightFix);
  } else {
    finalBlackLogoAndPriceRightFix();
  }

  window.addEventListener("resize", finalBlackLogoAndPriceRightFix);
  document.addEventListener("shopify:section:load", finalBlackLogoAndPriceRightFix);
})();
